import { customElement } from 'lit/decorators.js';
import { localized } from "@lit/localize";
import { UsosBox } from "./usos-box";
import style from './notice-box.scss';

/**
 * Notice/warning box information.
 */

@customElement('notice-box')
@localized()
export class NoticeBox extends UsosBox {
    static override styles = [...UsosBox.styles, style];

}

declare global {
    interface HTMLElementTagNameMap {
        'notice-box': NoticeBox
    }
}